import React from 'react';
import { TokenInfo } from '../types';
import './AssetSelector.css';

interface AssetSelectorProps {
    availableAssets: TokenInfo[];
    selectedAsset: TokenInfo;
    onAssetChange: (asset: TokenInfo) => void;
}

const AssetSelector = React.memo<AssetSelectorProps>(({
    availableAssets,
    selectedAsset,
    onAssetChange,
}) => {
    return (
        <div className="asset-selector">
            <div className="selector-header">
                <h3>Select Asset</h3>
            </div>

            <div className="assets-list">
                {[...availableAssets]
                    .sort((a, b) => a.symbol.toUpperCase().localeCompare(b.symbol.toUpperCase()))
                    .map((asset) => {
                    const isSelected = asset.mint === selectedAsset.mint;

                    return (
                        <button
                            key={asset.mint}
                            className={`asset-option ${isSelected ? 'selected' : ''}`}
                            onClick={() => onAssetChange(asset)}
                            disabled={isSelected}
                        >
                            <div className="asset-option-content">
                                <div className="asset-symbol-option">{asset.symbol.toUpperCase()}</div>
                                <div className="asset-details-option">
                                    <div className="asset-name-option">{asset.name}</div>
                                    <div className="decimals-info">{asset.decimals} decimals</div>
                                    <div className="asset-mint-option">{asset.mint.slice(0, 10)}...</div>
                                </div>
                            </div>
                        </button>
                    );
                })}
            </div>
        </div>
    );
});

export default AssetSelector; 
